<template>
  <div class="warpp">
    <div class="buts">
      <div
        v-show="customerTypeSee.type === typeObj.set.code"
        v-permit:remove="'btn:customer-managements:list:audit'"
      >
        <el-button
          v-if="ruleForm.auditState === 0"
          size="small"
          type="primary"
          @click="dialog.examineVisible = true"
        >{{ $t('customerManagements.AccountAudit') }}
        </el-button>
        <!-- 账户审核 -->
        <template v-else>
          <div v-permit:remove="'btn:customer-managements:list:lock'">
            <!-- 账户启用 -->
            <el-button v-if="ruleForm.lockState === 1" type="warning" @click="setLockState(0)">
              {{ $t('customerManagements.AccountOpening') }}
            </el-button>
            <!-- 账户停用 -->
            <el-button v-else type="danger" @click="setLockState(1)">{{ $t('customerManagements.AccountDisabled') }}
            </el-button>
          </div>
        </template>
      </div>
    </div>
    <el-form
      ref="ruleForm" :model="ruleForm" :rules="rules"
      class="demo-ruleForm" size="small"
    >
      <el-collapse v-model="activeNames" @change="handleChange">
        <!--    账户信息    -->
        <el-collapse-item :title="$t('customerManagements.accountInformation')" name="1">
          <el-row :gutter="20">
            <el-col :span="8">
              <!-- 客户类型 -->
              <el-form-item :label="$t('customerManagements.customerType')" prop="source">
                <el-select
                  v-model="ruleForm.source"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%"
                  @change="changeSource"
                >
                  <el-option :label="$t('customerManagements.enterprise')" value="corporation" />
                  <el-option :label="$t('customerManagements.personal')" value="person" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 审核状态 -->
              <el-form-item :label="$t('customerManagements.ApprovalStatus')">
                <el-select
                  v-model="ruleForm.auditState"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  disabled
                  filterable
                  style="width: 100%"
                >
                  <el-option :key="2" :label="$t('customerManagements.NotAudit')" :value="0" />
                  <el-option :key="3" :label="$t('customerManagements.approved')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 账户状态： -->
              <el-form-item :label="$t('customerManagements.AccountStatus')">
                <el-select
                  v-model="ruleForm.lockState"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  disabled
                  filterable
                  style="width: 100%"
                >
                  <el-option :key="2" :label="$t('customerManagements.enable')" :value="0" />
                  <el-option :key="3" :label="$t('customerManagements.Disable')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 账号层级 -->
              <el-form-item :label="$t('changepwd.accountLevel')" prop="level">
                <el-select
                  v-model="ruleForm.level"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%"
                  @change="changeLevel"
                >
                  <el-option key="1" :label="$t('changepwd.oneLeave')" :value="1" />
                  <el-option key="2" :label="$t('changepwd.twoLeave')" :value="2" />
                  <el-option key="3" :label="$t('changepwd.levelThree')" :value="3" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="[2, 3].includes(ruleForm.level)" :span="8">
              <!-- 上级账号 -->
              <el-form-item :label="$t('changepwd.superiorAccount')" prop="parentId">
                <el-select
                  v-model="ruleForm.parentId"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  filterable
                  style="width: 100%"
                  @change="getParentOptions"
                >
                  <el-option
                    v-for="item in parentAccountList"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 客户渠道 -->
              <el-form-item :label="$t('customerManagements.customerChannel')" prop="channel">
                <el-select
                  v-model="ruleForm.channel"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in channelList"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 账户名称 -->
              <el-form-item :label="$t('customerManagements.accountName')" prop="username">
                <el-input
                  v-model.trim="ruleForm.username"
                  :disabled="disabled"
                  :placeholder="$t('customerManagements.setConciseAccountName')"
                  maxlength="30"
                  show-word-limit
                  @input="handleUsernameInput"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 账户别称 -->
              <el-form-item :label="$t('customerManagements.AccountNickname')" prop="customerAlias">
                <el-input
                  v-model.trim="ruleForm.customerAlias"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  :readonly="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 网点 -->
              <el-form-item :label="$t('customerManagements.site')" prop="siteId">
                <el-select
                  v-model="ruleForm.siteId"
                  :disabled="readonly"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in siteIdList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 客户来源 -->
              <el-form-item :label="$t('changepwd.customerSource')" prop="customerSource">
                <el-select
                  v-model="ruleForm.customerSource"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in resCusList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 履约模式 -->
              <el-form-item prop="fulfillmentMode">
                <!-- 自定义 Label 插槽 -->
                <template slot="label">
                  <span style="margin-right: 1px">{{ $t('changepwd.fulfillmentMode') }}</span>
                  <!-- Tooltip 紧跟在 Label 文字右侧 -->
                  <el-tooltip
                    :append-to-body="true"
                    :content="$t('changepwd.fullOrderFulfillmentDesc')"
                    effect="dark"
                    placement="top"
                  >
                    <span class="custom-form-item">
                      <i class="el-icon-question custom-tooltip-icon" />
                    </span>
                  </el-tooltip>
                </template>
                <!-- 纯净的下拉框 -->
                <el-select
                  v-model="ruleForm.fulfillmentMode"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in resModeList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="customerTypeSee.type === typeObj.add.code" :span="8">
              <!-- 密码只能在新增的时候出现 -->
              <!-- 密码 -->
              <el-form-item :label="$t('customerManagements.accountPassword')" prop="password">
                <el-input
                  v-model.trim="ruleForm.password"
                  :disabled="disabled"
                  :maxlength="12"
                  :minlength="8"
                  :placeholder="$t('customerManagements.passwordPrompt')"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <!--    企业信息    -->
        <el-collapse-item
          v-if="ruleForm.source === 'corporation'"
          :title="$t('customerManagements.enterpriseInformation')"
          name="2"
        >
          <template>
            <el-row :gutter="20">
              <el-col :span="12">
                <!-- 企业名称 -->
                <el-form-item
                  :label="$t('changepwd.companyName')"
                  :rules="{
                    required: true,
                    message: $t('placeOrder.pleaseInput'),
                    trigger: ['blur', 'change']
                  }"
                  prop="company"
                >
                  <el-input
                    v-model.trim="ruleForm.company"
                    :placeholder="$t('customerManagements.pleaseEnterTheFullCompanyName')"
                    :readonly="readonly"
                    maxlength="100"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- CNPJ-->
                <el-form-item
                  :key="ruleForm.source"
                  :label="$t('customerManagements.cnpjMother')"
                  prop="cnpjMother"
                >
                  <el-input
                    v-model="ruleForm.cnpjMother"
                    :placeholder="$t('customerManagements.pleaseInput')"
                    :readonly="readonly"
                    clearable
                    @blur="checkCnpj(ruleForm.cnpjMother, ruleForm.id)"
                    @input="handleCnpjMother"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- 经营许可证 -->
                <el-form-item :label="$t('changepwd.operatingLicense')">
                  <el-upload
                    ref="upload"
                    :accept="acceptStr"
                    :before-upload="resumeBeforeAvatarUpload"
                    :file-list="fileList"
                    :http-request="resumeUpload"
                    :limit="4"
                    :multiple="false"
                    :on-remove="removeFile"
                    action
                    class="avatar-uploader"
                  >
                    <!-- 点击上传 -->
                    <el-button size="small" type="primary">{{ $t('customerManagements.clickUpload') }}
                    </el-button>
                    <!-- 可以上传图片，不超过5MB -->
                    <div slot="tip" class="el-upload__tip">
                      {{ $t('customerManagements.uploadPicturesNoMoreThan5MB') }}
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item
                  v-if="fileList.length > 0 || PDFFileList.length > 0"
                  :label="$t('customerManagements.attachmentHasBeenUploaded')"
                ><!-- 已上传附件 -->
                  <div class="demo-image__preview">
                    <!-- 图片 -->
                    <div
                      v-for="(item, index) of fileList"
                      :key="index"
                      class="imglist"
                      style="display: inline-block"
                    >
                      <img
                        :src="item.url"
                        alt=""
                        style="width: 100px; height: 100px; margin-right: 10px"
                      >
                    </div>
                    <!-- PDF -->
                    <div class="ullist">
                      <template v-for="item of PDFFileList">
                        <span :key="item.url" @click="handleSee(item.url)">{{ item.name }}</span>
                      </template>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <!--  州 -->
              <el-col :span="8">
                <el-form-item
                  :label="$t('placeOrder.State')"
                  :rules="{
                    required: true,
                    message: $t('GlobalSetObj.pleaseChoose'),
                    trigger: ['blur', 'change']
                  }"
                  prop="state"
                  style="width: 100%"
                >
                  <el-select
                    v-model="ruleForm.state"
                    :placeholder="$t('placeOrder.pleaseInput')"
                    :readonly="readonly"
                    clearable
                    filterable
                    style="width: 100%"
                    @change="changeState"
                    @focus="getAddress"
                  >
                    <el-option
                      v-for="item in StateList"
                      :key="item.id"
                      :label="item.shortName"
                      :value="item.shortName"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!--  城市 -->
              <el-col :span="8">
                <el-form-item
                  :label="$t('placeOrder.city')"
                  :rules="{
                    required: true,
                    message: $t('GlobalSetObj.pleaseChoose'),
                    trigger: ['blur', 'change']
                  }"
                  prop="city"
                  style="width: 100%"
                >
                  <el-select
                    v-model="ruleForm.city"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    :readonly="readonly"
                    :remote-method="getSenderCity"
                    clearable
                    filterable
                    remote
                    reserve-keyword
                    style="width: 100%"
                    @visible-change="getSenderCity()"
                  >
                    <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!--  街道 -->
              <el-col :span="8">
                <el-form-item :label="$t('newOrder.Street')" prop="street" style="width: 100%">
                  <el-input
                    v-model="ruleForm.street"
                    :placeholder="$t('placeOrder.pleaseInput')"
                    :readonly="readonly"
                    clearable
                    maxlength="50"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <!-- 门牌号 -->
              <el-col :span="8">
                <el-form-item
                  :label="$t('placeOrder.HouseNumber')"
                  prop="houseNumber"
                  style="width: 100%"
                >
                  <el-input
                    v-model="ruleForm.houseNumber"
                    :placeholder="$t('placeOrder.pleaseInput')"
                    :readonly="readonly"
                    clearable
                    maxlength="10"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 详细地址 -->
                <el-form-item :label="$t('placeOrder.detailedAddress')" prop="address">
                  <el-input
                    v-model="ruleForm.address"
                    :placeholder="$t('customerManagements.pleaseInput')"
                    :readonly="readonly"
                    maxlength="200"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <!-- 地址补充 -->
              <el-col :span="8">
                <el-form-item
                  :label="$t('placeOrder.addressComplement')"
                  prop="complement"
                  style="width: 100%"
                >
                  <el-input
                    v-model="ruleForm.complement"
                    :placeholder="$t('placeOrder.pleaseInput')"
                    :readonly="readonly"
                    clearable
                    maxlength="50"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--  IE号  -->
                <el-form-item :label="$t('changepwd.ieStateRegistration')" prop="ieNumber">
                  <el-input
                    v-model="ruleForm.ieNumber"
                    :placeholder="$t('customerManagements.pleaseInput')"
                    :readonly="readonly"
                    clearable
                    maxlength="18"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 邮编 -->
                <el-form-item :label="$t('orderDetails.zipcode')" prop="zipcode">
                  <el-input
                    v-model="ruleForm.zipcode"
                    :placeholder="$t('customerManagements.pleaseInput')"
                    :readonly="readonly"
                    clearable
                    maxlength="8"
                    @blur="zipcodeChange(ruleForm.zipcode)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <!-- 产品需求 -->
                <el-form-item
                  :label="$t('changepwd.productRequirements')"
                  prop="productRequirement"
                >
                  <el-input
                    v-model="ruleForm.productRequirement"
                    :placeholder="$t('customerManagements.pleaseInput')"
                    :readonly="readonly"
                    :rows="3"
                    clearable
                    type="textarea"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-collapse-item>
        <!--   联系信息  -->
        <el-collapse-item :title="$t('changepwd.contactInformation')" name="3">
          <el-row :gutter="20">
            <el-col :span="8">
              <!-- 联系人 -->
              <el-form-item :label="$t('company.contact')" prop="coPrincipalName">
                <el-input
                  v-model.trim="ruleForm.coPrincipalName"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  :readonly="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <!-- 证件号 -->
              <el-form-item
                :label="$t('orderCenterCont.CertificateCode')"
                prop="coPrincipalIdentityCard"
              >
                <el-input
                  v-model.trim="ruleForm.coPrincipalIdentityCard"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  :readonly="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 手机 -->
              <el-form-item :label="$t('GlobalSetObj.MobilePhone')" prop="customerPhone">
                <el-input
                  v-model.trim="ruleForm.customerPhone"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  :readonly="readonly"
                  maxlength="20"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 电话 -->
              <el-form-item :label="$t('GlobalSetObj.userPhone')" prop="coPrincipalTel">
                <el-input
                  v-model.trim="ruleForm.coPrincipalTel"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  :readonly="readonly"
                  maxlength="20"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 微信/QQ/Whatsapp -->
              <el-form-item :label="$t('changepwd.wechatQQWhatsapp')" prop="coPrincipalQq">
                <el-input
                  v-model.trim="ruleForm.coPrincipalQq"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  :readonly="readonly"
                  maxlength="20"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 邮箱 -->
              <el-form-item :label="$t('login.email')" prop="customerEmail">
                <el-input
                  v-model="ruleForm.customerEmail"
                  :placeholder="$t('operationCenter.PleaseEnterTheContent')"
                  :readonly="readonly"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
      <el-form-item>
        <div class="flx-end" style="margin-top: 15px; width: 100%">
          <div
            v-if="
              customerTypeSee.type === typeObj.add.code ||
                customerTypeSee.type === typeObj.edit.code
            "
          >
            <!-- 提交 -->
            <el-button type="primary" @click="onSubmit('ruleForm')">{{ $t('customerManagements.submit') }}
            </el-button>
            <!-- 重置 -->
            <el-button @click="resetForm('ruleForm')">{{ $t('customerManagements.reset') }}
            </el-button>
          </div>
          <div v-else class="flx-end" style="margin-left: 10px">
            <!-- 编辑 -->
            <el-button
              v-permit:remove="'btn:customer-managements:list:edit'"
              type="success"
              @click="onEditBtn('ruleForm')"
            >{{ $t('orderDetails.edit') }}
            </el-button>
            <div
              v-if="ruleForm.auditState !== 0"
              v-permit:remove="'btn:customer-managements:list:lock'"
              style="margin: 0 10px"
            >
              <!-- 账户启用 -->
              <el-button v-if="ruleForm.lockState === 1" type="warning" @click="setLockState(0)">
                {{ $t('customerManagements.enable') }}
              </el-button>
              <!-- 账户停用 -->
              <el-button v-else type="danger" @click="setLockState(1)">{{ $t('customerManagements.Disable') }}
              </el-button>
            </div>
            <!-- 重置密码 -->
            <el-button
              v-permit:remove="'btn:customer-managements:list:reset-pwd'"
              type="danger"
              @click="resetPwd"
            >
              {{ $t('userManage.resetPassword') }}
            </el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <!-- 账户审核 -->
    <!-- 提示 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('customerManagements.tips')"
      :visible.sync="dialog.examineVisible"
      width="30%"
    >
      <p class="dialog">
        <!-- 是否同意审核？ -->
        <span>{{ $t('customerManagements.IfAgreeAudit') }}</span>
        <!--  备注：审核通过后，该账户默认为                         停用                                          状态 -->
        <span>{{ $t('customerManagements.NoteDefaultAccount') }}
          <strong>{{ $t('customerManagements.Disable') }}</strong>
          {{ $t('customerManagements.accountState') }}</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialog.examineVisible = false">{{
          $t('customerManagements.cancel')
        }}</el-button>
        <!-- 确定 -->
        <el-button type="primary" @click="setAuditState">{{
          $t('customerManagements.confirm')
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 账户启用/停用 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('customerManagements.tips')"
      :visible.sync="dialog.lockVisible"
      width="30%"
    >
      <p class="dialog">
        <span>
          <!-- 确定对该账户进行 -->
          {{ $t('customerManagements.ConfirmOperationAccount') }}
          <!-- '启用' : '停用' -->
          <strong>{{
            dialog.obj.type == 0
              ? $t('customerManagements.enable')
              : $t('customerManagements.Disable')
          }}</strong>
          {{ $t('customerManagements.operation') }}
          <!-- 操作？ -->
        </span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.lockVisible = false">{{
          $t('customerManagements.cancel')
        }}</el-button><!-- 取消 -->
        <el-button type="primary" @click="determineLockState">{{
          $t('customerManagements.confirm')
        }}</el-button>
        <!-- 确定 -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchSiteIdList } from '@/api/lanshou';
import { emailReg } from '@/utils/reg_util';
import { uploadOos } from '@/utils/ali_oos_util';
import { TYPY_OBJ } from '@/enums/customerEnums';
import { imgTypeArr, pdfTypeArr } from '@/enums/evaluateEnums';
import {
  apiCustomerAdd,
  apiCustomerCheckCnpj,
  apiCustomerEdit,
  apiCustomerFindById,
  apiCustomerStateHandler,
  getCustomerChannelList,
  getCustomerParentOptions,
  getCustomerTimeList
} from '@/api/customer';
import { getAddressByZipCode, selectCity, selectState } from '@/api/orderApi';
import { getRSA, strRSA } from '@/utils/RSA_util';
import { mapState } from 'vuex';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { cloneDeep } from 'lodash-es';
import md5 from 'js-md5';
import { checkCNPJ, checkNumber, ieNumber } from '@/utils/validate';
import { formatCnpj } from '@/utils/strUtil';

export default {
  props: {
    ids: {
      type: [String, Number],
      default: ''
    },

    customerType: {
      type: Object,
      default() {
        return {
          id: '',
          type: 'add'
        };
      }
    }
  },
  computed: mapState({
    managerList: (state) => state.user.managerList
  }),
  data() {
    /**
     * 账户名校验
     * 防止出现重复用户名
     */
    const usernameCheck = (rule, value, callback) => {
      if (this.disabled) return callback();
      if (!value.length) {
        return callback(new Error(this.$t('customerManagements.accountNameNotEmpty'))); // '账户名称不能为空'
      }

      // 过滤空格并转换为小写
      const processedValue = value.replace(/\s/g, '').toLowerCase();
      // 检查长度限制（不超过30字符）
      if (processedValue.length > 30) {
        return callback(new Error(this.$t('customerManagements.accountNameMaxLength'))); // '账户名长度不能超过30个字符'
      }
      // 检测特殊语种字母（如葡萄牙字母：á, à, â, ã, ç, é, ê, í, ó, ô, õ, ú, ü 等）
      const specialCharRegex = /[^\x00-\x7F]/; // 匹配非 ASCII 字符
      if (specialCharRegex.test(processedValue)) {
        return callback(new Error(this.$t('customerManagements.accountNameContainsSpecialChars')));
      }
      // 检查只包含字母、数字和连接线
      const validPattern = /^[a-z0-9\-_]+$/;
      if (!validPattern.test(processedValue)) {
        return callback(new Error(this.$t('customerManagements.accountNameAllowedChars'))); // '账户名只能包含字母、数字和连接线(-_)'
      }
      this.ruleForm.username = processedValue;

      if (this.ruleForm.id) {
        return callback();
      }
      callback();
    };

    // 密码后台暂时不做限制，只有前端校验
    const passwordCheck = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error(this.$t('customerManagements.notNull'))); // '密码不能为空'
      }
      // const reg = /^[\w]{8,12}$/;
      const reg = /(?=.*[0-9].*)(?=.*[A-Z].*)|(?=.*[0-9].*)(?=.*[a-z].*).{8,12}$/;
      if (!reg.test(value)) {
        return callback(new Error(this.$t('customerManagements.input8to12SumCode'))); // '请输入8-12位数字和英文组合'
      }
      this.pwd = md5(md5(value));
      callback();
    };
    // 包裹误差
    const priceType = (rule, value, callback) => {
      const reg = new RegExp(
        '(^[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^0(\\.\\d{1,' + rule.suffix + '})?$)'
      );
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('customerManagements.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('customerManagements.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$t('customerManagements.notNull')); // '不能为空'
        }
      }
    };
    return {
      StateList: [],
      cityList: [],
      pwd: '', // 加密的密码
      disabled: false, // 是否禁用
      readonly: false, // 仅在查看时使用
      ruleForm: {
        id: '',
        source: 'corporation', // corporation:企业，person:个人
        customerAlias: '', // 账户别称
        company: '', // 公司名称
        coPrincipalName: '', // 企业负责人名字
        coPrincipalPhone: '', // 企业负责人手机电话
        coPrincipalTel: '', // 企业负责人电话
        coPrincipalEmail: '', // 企业负责人邮箱
        packageDeviation: '', // 包裹误差
        coPrincipalQq: '', // 企业负责人QQ
        address: '', // 公司(个人)地址
        identityCard: '', // 营业执照或身份证号 '9144030059073074XQ'
        identityCardAttachment: '', // 证件照附件
        logisticsContactsName: '', // 物流联系人名字
        logisticsContactsPhone: '', // 物流联系人手机
        logisticsContactsTel: '', // 物流联系人电话
        logisticsContactsEmail: '', // 物流联系人邮箱
        logisticsContactsQq: '', // 物流联系人QQ
        password: '', // 密码
        auditState: 0, // 账户审核，0：未审核，1：已审核
        lockState: 1, // 账号锁定，0：正常，1：锁定
        integral: '0', // 积分
        handlerIdList: [], // 经办人id
        username: '', // 账户名称
        siteId: '', // 站点
        customerPhone: '', // 客户手机
        customerEmail: '', // 客户邮箱
        orderNumberType: '',
        cnpjMother: '',
        cnpjSon: '',
        ieNumber: '',
        zipcode: '',
        houseNumber: '',
        complement: '',
        street: '',
        city: '',
        state: '',
        coPrincipalIdentityCard: '',
        productRequirement: '',
        channel: '',
        level: '',
        parentId: '',
        customerSource: '',
        fulfillmentMode: ''
      },
      siteIdList: [], // 站点list
      rules: {
        cnpjMother: [
          {
            required: true,
            message: this.$t('customerManagements.inputFormat'),
            trigger: ['blur', 'change']
          },
          { validator: checkCNPJ, trigger: ['blur', 'change'] }
        ],
        packageDeviation: [
          { required: false, suffix: 3, validator: priceType, trigger: ['blur', 'change'] }
        ],
        // '请选择站点'
        siteId: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseCheckSite'),
            trigger: ['blur', 'change']
          }
        ],
        level: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        customerSource: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        fulfillmentMode: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        parentId: [
          {
            required: false,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        customerPhone: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        coPrincipalName: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        customerEmail: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseInput'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value && !emailReg.test(value)) {
                return callback(new Error(this.$t('customerManagements.enterValidCustomerEmail'))); // '请输入正确的客户邮箱'
              } else {
                callback();
              }
            }
          }
        ],
        password: [{ required: true, validator: passwordCheck, trigger: ['blur', 'change'] }],
        username: [
          { required: !this.disabled, validator: usernameCheck, trigger: ['blur', 'change'] }
        ],
        customerAlias: [
          {
            required: true,
            message: this.$t('customerManagements.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        ieNumber: [{ required: true, validator: ieNumber, trigger: ['blur', 'change'] }],
        houseNumber: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        complement: [
          {
            required: false,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        source: [{ required: true }],
        street: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        zipcode: [
          { required: true, validator: checkNumber, trigger: ['blur', 'change'] },
          {
            min: 8,
            message: this.$t('mdfeTranslate.tip8Number'),
            trigger: ['blur', 'change']
          }
        ]
      },
      acceptStr: '', // 上传附件类型
      fileList: [], // 上传
      imgFileList: [], // 图片
      PDFFileList: [], // PDF
      typeObj: TYPY_OBJ, // 当前状态
      dialog: {
        examineVisible: false,
        lockVisible: false,
        obj: {
          idList: [],
          // type: 1, // 状态类型: 1:账号锁定状态，2.账户审核状态
          value: 0
        }
      },
      // 用户列表
      userList: [],
      activeNames: ['1', '2'],
      channelList: [],
      parentAccountList: [],
      customerTypeSee: {
        id: '',
        type: 'add'
      },
      resCusList: [],
      resModeList: []
    };
  },
  watch: {
    customerTypeSee: {
      handler(newVal) {
        console.log(newVal, 'newVal');
        this.resetRuleForm();
        // console.log('传进来的数据', newVal.type);
        if (newVal.type === 'edit' || newVal.type === 'examine' || newVal.type === 'set') {
          this.disabled = true;
          this.activeNames = ['1', '2'];
        } else {
          this.disabled = false;
        }
        if (newVal.type === 'add') {
          this.disabled = false;
          this.fileList = []; // 清空文件列表
          this.activeNames = ['1', '2', '3', '4', '5', '6'];
        }
        if (newVal.type === 'examine') {
          // readonly="true" 仅在查看时有效
          this.readonly = true;
          this.activeNames = ['1', '2'];
        } else {
          this.readonly = false;
        }
        if (newVal.type === TYPY_OBJ.add.code) {
          // 新增
          return;
        }
        this.ruleForm.id = newVal.id;
        this.getCustimerData(newVal.id);
      },
      immediate: true,
      deep: true
    }
  },

  created() {
    console.log(this.customerType, 'customerType');
    this.customerTypeSee = { ...this.customerType };
    this.acceptStr = [...imgTypeArr, ...pdfTypeArr].join(',');
    this.userList = Object.entries(getUserIdAndNameObj()).map((item) => {
      const obj = {
        label: item[1],
        value: Number(item[0])
      };
      return Object.freeze(obj);
    });
    searchSiteIdList().then((res) => {
      if (res.code === 200) {
        res.data.forEach((data) => {
          this.siteIdList.push({ id: data.id, name: data.name });
        });
      }
    });
    this.getAddress();
    this.getChannel();
    this.getRecordField();
  },

  methods: {
    // 获取时效列表
    async getRecordField() {
      const resCus = await getCustomerTimeList('customer_source');
      const resMode = await getCustomerTimeList('fulfillment_mode');
      if (resCus.data) {
        this.resCusList = resCus.data;
      }
      if (resMode.data) {
        this.resModeList = resMode.data;
      }
    },
    async changeLevel(val) {
      this.ruleForm.parentId = '';
      this.ruleForm.channel = '';
      if (val && val !== 1) {
        this.rules.parentId = [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ];
        const dataVal = val === 2 ? 1 : 2;
        const result = await getCustomerParentOptions(dataVal);
        this.parentAccountList = result.data;
        console.log(result, 'getCustomerParentOptions');
      } else {
        this.rules.parentId = [
          {
            required: false,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ];
      }
    },
    // 切换上级账号
    getParentOptions(val) {
      if (val) {
        console.log(val, 'getParentOptions', this.parentAccountList);
        const obj = this.parentAccountList.find((item) => item.id === val);
        console.log(obj, 'obj');
        this.ruleForm.channel = obj.channel;
      } else {
        this.ruleForm.channel = '';
      }
    },
    handleUsernameInput(value) {
      if (!value) return;
      // 实时处理输入：过滤空格、转小写、限制特殊字符
      let processedValue = value.replace(/\s/g, '').toLowerCase();
      if (processedValue.length > 30) {
        processedValue = processedValue.substring(0, 30);
      }
      this.ruleForm.username = processedValue;
    },
    handleChange(val) {
      console.log(val);
    },
    // ...mapActions({ getManager: 'user/getManagerList' }),
    // 清空数据
    resetRuleForm() {
      for (const key in this.ruleForm) {
        this.ruleForm[key] = '';
      }
      this.ruleForm.source = 'corporation';
      this.ruleForm.auditState = 0;
      this.ruleForm.lockState = 1;
      this.ruleForm.integral = '0';
    },
    changeSource() {
      this.ruleForm.identityCard = '';
    },
    /**
     * 获取指定客户数据
     */
    getCustimerData(ids) {
      apiCustomerFindById(ids)
        .then((res) => {
          if (res.code === 200) {
            const {
              id,
              source,
              company,
              coPrincipalName,
              coPrincipalPhone,
              packageDeviation,
              coPrincipalTel,
              coPrincipalEmail,
              coPrincipalQq,
              address,
              identityCard,
              identityCardAttachment,
              // financeContactsName,
              // financeContactsPhone,
              // financeContactsTel,
              // financeContactsEmail,
              // financeContactsQq,
              logisticsContactsName,
              logisticsContactsPhone,
              logisticsContactsTel,
              logisticsContactsEmail,
              logisticsContactsQq,
              ftpUploadPath,
              username,
              siteId, // 站点
              customerPhone, // 客户手机
              customerEmail, // 客户邮箱
              customerAlias,
              auditState,
              lockState,
              integral,
              authorizationCode,
              handlerIdList,
              // useVolumeBilling,
              // calculationMethod,
              // calculateBase,
              // billingMethod, // 报价方式
              ftpHost, // ftp地址
              ftpUsername, // ftp账号
              ftpPassword, // ftp密码
              ftpPort, // ftp端口
              ftpPath, // ftp路径
              ftpType, // 连接类型
              orderNumberType,
              cnpjMother,
              cnpjSon,
              ieNumber,
              zipcode,
              houseNumber,
              complement,
              street,
              city,
              state,
              isTrackStopAlert,
              trackStopAlertDays,
              coPrincipalIdentityCard,
              productRequirement,
              channel,
              level,
              parentId,
              deliveryNoteFlag,
              customerSource,
              fulfillmentMode
            } = res.data;
            this.changeLevel(level);
            let enclosureArr = [];
            if (identityCardAttachment != null) {
              if (identityCardAttachment.length) {
                enclosureArr = identityCardAttachment
                  .split(',')
                  .map((item) => {
                    return getRSA(item);
                  })
                  .map((item) => {
                    return this.getLastUploadArr(item);
                  });
              }
            }

            // this.editFileList = enclosureArr;
            {
              // 附件
              this.fileList = cloneDeep(enclosureArr);
              const { imgArr, pdfArr } = this.getImgAndPDFType(enclosureArr);
              this.imgFileList = imgArr;
              this.PDFFileList = pdfArr;
            }

            const obj = {
              id,
              source, // corporation:企业，person:个人
              company, // 公司名称
              coPrincipalName, // 企业负责人名字
              coPrincipalPhone, // 企业负责人手机电话
              coPrincipalTel, // 企业负责人电话
              coPrincipalEmail, // 企业负责人邮箱
              coPrincipalQq, // 企业负责人QQ
              address, // 公司(个人)地址
              identityCard, // 营业执照或身份证号
              packageDeviation, // 包裹误差
              identityCardAttachment, // 证件照附件
              // parentId: '', // 上级id(客户公司的上下级关系)
              // customServiceUserId: '', // 客服id(oa系统中的用户id)
              // financeContactsName, // 财务联系人名字
              // financeContactsPhone, // 财务联系人手机
              // financeContactsTel, // 财务联系人电话
              // financeContactsEmail, // 财务联系人邮箱
              // financeContactsQq, // 财务联系人qq
              logisticsContactsName, // 物流联系人名字
              logisticsContactsPhone, // 物流联系人手机
              logisticsContactsTel, // 物流联系人电话
              logisticsContactsEmail, // 物流联系人邮箱
              logisticsContactsQq, // 物流联系人QQ
              ftpUploadPath,
              username, // 账户名称
              password: '', // 密码 不显示
              siteId, // 站点
              customerPhone, // 客户手机
              customerEmail, // 客户邮箱
              auditState,
              lockState,
              customerAlias,
              integral: integral || '0', // 积分，
              // handlerId: handlerId ? Number(handlerId) : '',
              handlerIdList,
              // billingMethod, // 报价方式
              ftpHost, // ftp地址
              ftpUsername, // ftp账号
              ftpPassword, // ftp密码
              ftpPort, // ftp端口
              ftpPath, // ftp路径
              ftpType, // 连接类型
              orderNumberType,
              cnpjMother,
              cnpjSon,
              ieNumber,
              zipcode,
              houseNumber,
              complement,
              street,
              city,
              state,
              isTrackStopAlert,
              trackStopAlertDays,
              coPrincipalIdentityCard,
              productRequirement,
              channel,
              level,
              parentId,
              deliveryNoteFlag,
              customerSource,
              fulfillmentMode
            };
            Object.assign(this.ruleForm, obj);
            this.$emit('updataAuthorizationCode', authorizationCode || '', res.data);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 区分图片和PDF
    getImgAndPDFType(arr) {
      const imgArr = [];
      const pdfArr = [];
      const pdfReg = /.pdf$/g;
      arr.forEach((item) => {
        if (pdfReg.test(item.url)) {
          pdfArr.push(item);
        } else {
          imgArr.push(item.url);
        }
      });
      return {
        imgArr,
        pdfArr
      };
    },
    onEditBtn() {
      this.customerTypeSee.type = 'edit';
    },
    // 提交
    onSubmit(formName) {
      let isValid = true;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message({
            message: this.$t('customerManagements.PleaseFillRequiredFieldsCorrectly'), // '请正确填写必填项'
            type: 'warning'
          });
          isValid = false;
          return false;
        }
      });
      if (!isValid) {
        return;
      }
      const ruleForm = this.setData();
      if (this.ruleForm.id) {
        // 编辑
        this.asyncUserEdit(ruleForm);
      } else {
        this.asyncUserAdd(ruleForm);
      }
    },

    setData() {
      const ruleForm = cloneDeep(this.ruleForm);
      // 因为字符串太长 rsa 分段加密
      ruleForm.identityCardAttachment = this.fileList
        .map((item) => {
          return strRSA(item.url);
        })
        .join(',');

      ruleForm.password = this.pwd;

      // 选择个人，清空企业数据
      if (ruleForm.source === 'person') {
        ruleForm.company = '';
        ruleForm.coPrincipalName = '';
        ruleForm.coPrincipalPhone = '';
        ruleForm.coPrincipalTel = '';
        ruleForm.coPrincipalEmail = '';
        ruleForm.coPrincipalQq = '';
      }

      // 如果没有勾选 使用材积计费，则不传字段
      // if (ruleForm.useVolumeBilling === 0) {
      //   ruleForm.calculationMethod = undefined;
      //   ruleForm.calculateBase = undefined;
      // }
      if (!ruleForm.handlerIdList) {
        ruleForm.handlerIdList = [];
      }
      return ruleForm;
    },

    // 重置
    resetForm(formName) {
      this.fileList = [];
      this.disabled = false;
      for (const key in this.ruleForm) {
        if (key === 'username' || key === 'integral' || key === 'id') {
          this.disabled = true;
        } else {
          this.ruleForm[key] = '';
        }
      }
      this.ruleForm.source = 'corporation';
      this.ruleForm.auditState = 0;
      this.ruleForm.lockState = 1;
      this.ruleForm.integral = '0';
      // this.ruleForm.billingMethod = 0; // 报价方式
      // this.ruleForm.type = 1;
      if (this.activeNames.length >= 4) {
        this.disabled = false;
      }
    },

    /**
     * 删除
     */
    resumeRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },

    /**
     * 上传前的控制
     */
    resumeBeforeAvatarUpload(file) {
      const typeArr = [...imgTypeArr, ...pdfTypeArr];
      const { type, size } = file;
      // const isPDF = type === 'application/pdf';
      // console.log(1);
      const isType = typeArr.includes(type);

      const isLt5M = size / 1024 / 1024 < 5;
      if (!isType) {
        //                 上传只能是                                                        格式!
        this.$message.error(
          ` ${this.$t('customerManagements.UploadOnlyBe')}${typeArr.join('/')}${this.$t(
            'customerManagements.format'
          )} `
        );
      }
      if (!isLt5M) {
        this.$message.error(this.$t('customerManagements.sizeNoMoreThan2MB')); // '上传大小不能超过 2MB!'
      }
      return isType && isLt5M;
    },

    /**
     * 上传
     */
    resumeUpload(option) {
      const { file } = option;
      uploadOos(file, 'customer')
        .then((res) => {
          if (res.code === 200) {
            const obj = {
              name: file.name,
              url: res.url
            };
            this.fileList = [...this.fileList, obj];
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          // this.$refs['excel-upload-input'].value = '';
        });
    },

    // 移除文件触发
    removeFile(file, fileList) {
      this.fileList = fileList;
    },

    /**
     * 新增
     */
    asyncUserAdd(obj) {
      apiCustomerAdd(obj)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: this.$t('customerManagements.AddedSuccessfully'), // '添加成功'
              type: 'success'
            });

            setTimeout(() => {
              this.$emit('updataData');
            }, 1500);
            this.ruleForm.password = '';
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    /**
     * 编辑
     */
    asyncUserEdit(obj) {
      // 根据需求将账户名称进行置空处理
      const newObj = cloneDeep(obj);
      newObj.username = '';
      newObj.password = '';

      apiCustomerEdit(obj)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: this.$t('customerManagements.ModificationSuccessful'), // '修改成功'
              type: 'success'
            });

            setTimeout(() => {
              this.$emit('updataData');
            }, 1500);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 显示之前上传的附件
    getLastUploadArr(str) {
      if (str) {
        const newStr = decodeURI(str);
        const URLArr = newStr.split('/');
        const name = URLArr[URLArr.length - 1];
        return {
          name,
          url: str
        };
      }
    },
    /**
     * 账户审核通过
     */
    setAuditState() {
      this.dialog.obj.idList = [this.ruleForm.id];
      this.dialog.obj.type = 2;
      this.dialog.obj.status = 1;
      this.asyncStateHandler(
        this.dialog.obj,
        this.$t('customerManagements.AccountVerificationSucceeded')
      ); // '账号审核成功'
    },

    /**
     * 账户 启用/停用
     */
    setLockState(value) {
      this.dialog.lockVisible = true;
      this.dialog.obj.idList = [this.ruleForm.id];
      this.dialog.obj.type = value;
      this.dialog.obj.status = value;
    },
    resetPwd() {
      this.$emit('resetPwd');
    },
    /**
     * 确定
     */
    determineLockState() {
      const { value } = this.dialog.obj;
      if (value === 1) {
        // 账户停用
        this.asyncStateHandler(
          this.dialog.obj,
          this.$t('customerManagements.accountHasBeenDeactivated')
        ); // '该账号已停用'
      } else {
        // 账户启用
        this.asyncStateHandler(
          this.dialog.obj,
          this.$t('customerManagements.accountHasBeenEnabled')
        ); // '该账号已启用'
      }
    },

    /**
     * 状态控制
     */
    asyncStateHandler(obj, message = '') {
      apiCustomerStateHandler(obj)
        .then((res) => {
          if (res.code === 200) {
            this.dialog.examineVisible = false;
            this.dialog.lockVisible = false;
            this.$message({
              message,
              type: 'success'
            });
            this.getCustimerData(this.ruleForm.id);

            setTimeout(() => {
              this.$emit('updataData', false);
            }, 1500);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // pdf 预览
    handleSee(url) {
      window.open(url);
    },
    handleCnpjMother(val) {
      this.ruleForm.cnpjMother = formatCnpj(val);
    },
    checkCnpj(cnpj, id) {
      const data = {
        cnpj: cnpj,
        id: id
      };
      apiCustomerCheckCnpj(data)
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error(res.msg);
          }
        })
        .catch({});
    },
    zipcodeChange(zipcode) {
      if (zipcode && zipcode.length === 8) {
        getAddressByZipCode(zipcode).then((res) => {
          console.log(res, '===res');
          if (res.code === 200) {
            if (res.data.state) {
              this.ruleForm.state = res.data.state;
            }
            if (res.data.city) {
              this.ruleForm.city = res.data.city;
            }
            if (res.data.street) {
              this.ruleForm.street = res.data.street;
            }
            if (res.data.houseNumber) {
              this.ruleForm.houseNumber = res.data.houseNumber;
            }
          }
        });
      }
    },
    // 获取城市
    getSenderCity(name = '') {
      let id = null;
      this.StateList.map((item) => {
        if (item.shortName === this.ruleForm.state) {
          id = item.id;
        }
      });
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id,
          name
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.cityList = res.data.records;
        }
      });
    },
    // 州
    getAddress() {
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.records;
        }
      });
    },
    changeState() {
      this.ruleForm.city = '';
    },
    getChannel() {
      getCustomerChannelList().then((res) => {
        if (res.code === 200) {
          this.channelList = res.data || [];
        }
      });
    }
  }
};
</script>

<style scoped>
.siteClass ::v-deep .el-select {
  width: 100%;
}

.warpp {
  height: calc(100vh - 150px);
  overflow-y: auto;
  width: 100%;
}

.warpp /deep/ .el-collapse-item__header {
  color: #00A551;
  font-size: 16px;
}

.warpp /deep/ .el-descriptions-item__label {
  font-size: 13px;
  color: #909399;
}

.warpp /deep/ .el-descriptions-item__cell {
  /*height: 35px !important;*/
  padding-bottom: 2px !important;
}

.mt10 {
  margin-top: 10px;
}

.dialog {
  display: flex;
  flex-direction: column;
}

.dialog span:first-child {
  font-weight: bold;
  font-size: 16px;
}

.dialog span:last-child {
  margin-top: 15px;
  color: #909399;
}

.dialog span strong {
  color: #e6a23c;
}

.buts {
  /* width: 95%; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* border: 1px solid #000; */
  margin-bottom: 10px;
}

a.links {
  display: block;
}

.ullist {
  display: flex;
  flex-direction: column;
}

.ullist span {
  cursor: pointer;
  color: #00A551;
  font-size: 14px;
  font-weight: 500;
}

.volume {
  display: flex;
  /* border: 1px solid #000; */
}

/* 让 form-item 变成相对定位 */
.custom-form-item {
  position: relative;
}

/* 把图标绝对定位到 label 的右侧 */
.custom-tooltip-icon {
  position: absolute;
  top: 0; /* 根据实际 label 高度微调 */
  color: #909399;
  cursor: pointer;
  z-index: 99999;
  font-size: 16px;
}
</style>
